module.exports = __webpack_public_path__ + "static/media/block-pout.099bb73a.png";


//////////////////
// WEBPACK FOOTER
// ./src/story/sprites/block-pout.png
// module id = 85
// module chunks = 0